import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/landing/Hero';
import About from '../components/landing/About';
import Features from '../components/landing/Features';
import WhyChoose from '../components/landing/WhyChoose';
import Security from '../components/landing/Security';
import CTA from '../components/landing/CTA';
import '../components/landing/Landing.css';

export default function LandingPage() {
  const location = useLocation();

  // Scroll to hash anchor after navigation
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 80);
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location]);

  return (
    <div className="landing">
      <Hero />
      <About />
      <Features />
      <WhyChoose />
      <Security />
      <CTA />
    </div>
  );
}
